import { Injectable, inject } from '@angular/core';
import { Http, QueryHandlerFor } from '@skylab-angular-shared/core';
import { PagedCollectionQuery, PagedCollectionQueryResult, PagedCollectionQueryResultDTO } from '@skylab-shared/business';
import { HttpService, QueryHandler, TaggedUrl, Tags, transformDTODate } from '@skylab-shared/core';
import { Mutable } from '@skylab-shared/types';
import { Transform } from 'class-transformer';

export type InventoryMovementReportGridItem = Omit<InventoryMovementReportGridInternalItemDTO, 'quantityGoodsReceipt' | 'quantityGoodsIssue'> & {
    quantityGoodsReceipt: string;
    quantityGoodsIssue: string;
};

class InventoryMovementReportGridInternalItemDTO {
    public readonly id: number;
    public readonly documentNumber: string;
    @Transform(transformDTODate, { toClassOnly: true })  public readonly issueDate: Date;
    @Transform(transformDTODate, { toClassOnly: true })  public readonly goodsIssueDate: Date;
    public readonly quantityGoodsIssue: number;
    public readonly costGoodsIssue: number;
    public readonly quantityGoodsReceipt: number;
    public readonly costGoodsReceipt: number;
    public readonly currency: string;
};

export class InventoryMovementReportGridQuery extends PagedCollectionQuery<InventoryMovementReportGridItem> { }

@Injectable({ providedIn: 'root'})
@QueryHandlerFor(InventoryMovementReportGridQuery)
export class InventoryMovementReportGridQueryHandler implements QueryHandler<InventoryMovementReportGridQuery, PagedCollectionQueryResult<InventoryMovementReportGridItem>> {
    #url = TaggedUrl.join('productMovements', [Tags.Api]);
    #http = inject(Http) as HttpService;

    public async handleAsync(query: InventoryMovementReportGridQuery): Promise<PagedCollectionQueryResult<InventoryMovementReportGridItem>> {
        const { data } = await this.#http.get<Mutable<PagedCollectionQueryResult<InventoryMovementReportGridInternalItemDTO>>>(this.#url, {
            params: { ...query.params },
            dtoObject: new PagedCollectionQueryResultDTO<InventoryMovementReportGridInternalItemDTO>(InventoryMovementReportGridInternalItemDTO)
        });

        const items = data.items?.map(elem => ({
            ...elem,
            quantityGoodsIssue: elem.quantityGoodsIssue?.toString().replace('.', ','),
            quantityGoodsReceipt: elem.quantityGoodsReceipt?.toString().replace('.', ',')
        }));

        return {
            items: items,
            totalItemsCount: data.totalItemsCount
        };
    }
}
